module.exports = __webpack_public_path__ + "img/hands.d1a2c438.png";